<div class="team-member-card p-4 flex flex-col h-full max-w-[220px] bg-surface-800 rounded-lg">
  <!-- Member Image -->
  <div class="member-image-container flex justify-center mb-4">
    @if (member.imagePreview) {
    <img
      [src]="member.imagePreview"
      [alt]="member.name"
      class="w-20 h-20 rounded-full object-cover border-2 border-gray-600"
    />
    } @else {
    <div class="w-20 h-20 rounded-full bg-gray-600 flex items-center justify-center border-2 border-gray-600">
      <i class="pi pi-user text-2xl text-muted"></i>
    </div>
    }
  </div>

  <!-- Member Name -->
  <h4 class="text-heading-md text-white mb-2 text-center">{{ member.name }}</h4>

  <!-- Member Position -->
  <p class="text-caption-lg font-medium text-secondary mb-3 text-center">{{ member.position }}</p>

  <!-- LinkedIn Link -->
  @if (member.linkedinUrl) {
  <div class="linkedin-container mb-3 text-center">
    <a
      [href]="member.linkedinUrl"
      target="_blank"
      class="text-info text-caption-lg">
    >
      LinkedIn
    </a>
  </div>
  }

  <!-- Member Description -->
  <p class="text-body-sm text-secondary leading-relaxed mb-4 flex-grow text-center line-clamp-3">{{ member.description }}</p>

  <!-- Action Buttons -->
  <div class="action-buttons flex gap-2 justify-end">
    <p-button
      icon="pi pi-pencil"
      [rounded]="true"
      size="small"
      (onClick)="onEdit()"
      [ariaLabel]="'projectEdit.teamMembers.editMember' | translate"
    />
    <p-button
      icon="pi pi-trash"
      [rounded]="true"
      size="small"
      severity="danger"
      (onClick)="onRemove()"
      [ariaLabel]="'projectEdit.teamMembers.removeMember' | translate"
    />
  </div>
</div>